import React from 'react'

export default function CdcStats() {
    return (
        <div>
            THis is CDC Stats part of quick info
        </div>
    )
}
